import {
  Icon,
  Link,
  Stack,
  Text,
  TooltipHost,
  useTheme,
} from '@fluentui/react';
import clsx from 'clsx';
import { useCommonStyles } from 'common/styles';
import React from 'react';
import ApprovedIcon from '../../../../../assets/svgs/ApproveStatusIcons/Approved.svg?react';
import { CompanyConfigurationCategories_companyConfigurationCategories_nodes } from '../../__generated__/CompanyConfigurationCategories';
import { useStyles } from './index.styles';

interface CategoryHeaderProps {
  id: string;
  isSelected: boolean;
  node: CompanyConfigurationCategories_companyConfigurationCategories_nodes;
  headerOnClick: (
    selectedNode: CompanyConfigurationCategories_companyConfigurationCategories_nodes
  ) => void;
}

export const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  isSelected,
  node,
  headerOnClick,
}) => {
  const commonStyles = useCommonStyles();
  const styles = useStyles();
  const theme = useTheme();
  const ruleCount = node?.businessRuleCount;
  return (
    <Stack
      id={node.id}
      horizontal
      className={clsx(styles.root, isSelected && styles.groupSelected)}
      tokens={{ childrenGap: 50 }}
    >
      <Link
        style={{ textDecoration: 'none' }}
        onClick={() => {
          headerOnClick(node);
        }}
      >
        <Stack verticalAlign="center" horizontal tokens={{ childrenGap: 20 }}>
          <Stack
            horizontal
            tokens={{ childrenGap: 10 }}
            style={{ width: 300 }}
            verticalAlign="center"
          >
            <Icon iconName={'EntitlementPolicy'} />
            <Text
              nowrap
              block
              className={commonStyles.semibold}
              variant="medium"
            >
              {node.name}
            </Text>
            {node.isComplete && (
              <ApprovedIcon style={{ height: 20, width: 20 }} />
            )}
            {node?.warningMessage && (
              <TooltipHost content={node?.warningMessage}>
                <Icon
                  iconName="Warning"
                  style={{
                    color: theme.palette.redDark,
                    fontSize: 18,
                  }}
                />
              </TooltipHost>
            )}
            <Text variant="medium" className={styles.groupName}>
              {`(${ruleCount})`}
            </Text>
          </Stack>
        </Stack>
      </Link>
    </Stack>
  );
};
